
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_2719_6181)"}},[_c('path',{attrs:{"fill":"#fff","fill-opacity":".01","d":"M0 0h16v16H0z"}}),_c('g',{attrs:{"clip-path":"url(#clip1_2719_6181)"}},[_c('path',{attrs:{"d":"M14 0a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2h12zM2 1a1 1 0 00-1 1v12a1 1 0 001 1h12a1 1 0 001-1V2a1 1 0 00-1-1H2zm5.5 3.498a.503.503 0 01.354.855L5.707 7.499H11.5a.5.5 0 010 1H5.707l2.147 2.147a.503.503 0 01.109.545.503.503 0 01-.655.271.502.502 0 01-.162-.11l-3-3a.5.5 0 01-.11-.544.5.5 0 01.11-.162l3-3a.5.5 0 01.354-.148z","fill":"#6C757D"}})])]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_2719_6181"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})]),_c('clipPath',{attrs:{"id":"clip1_2719_6181"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    